export default __webpack_public_path__ + "static/media/testimonial_kocica.7c093ad0.jpg";